import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductRoutingModule } from './product-routing.module';
import { ProductComponent } from './product.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ProductSortingComponent } from './components/product-sorting/product-sorting.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { ProductGridComponent } from './components/product-grid/product-grid.component';
import { ProductViewSliderComponent } from './components/product-view-slider/product-view-slider.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider'
import { NgxNumberSpinnerModule } from '../ngx-number-spinner/ngx-number-spinner.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
// import { StorageServiceModule } from 'ngx-webstorage';
import { SuggestedProductsComponent } from './components/suggested-products/suggested-products.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {NgcCookieConsentModule} from 'ngx-cookieconsent';
import { RecommendedProductsComponent } from './components/recommended-products/recommended-products/recommended-products.component';
import { SidebarFiltersComponent } from './components/sidebar-filters/sidebar-filters.component';

@NgModule({
  declarations: [ProductComponent,
  ProductSortingComponent, ProductDetailComponent, ProductGridComponent,
  ProductViewSliderComponent,
  SuggestedProductsComponent,
  RecommendedProductsComponent,
  SidebarFiltersComponent
],
  imports: [
    CommonModule,
    ProductRoutingModule,
    InfiniteScrollModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    SlickCarouselModule,
    CarouselModule.forRoot(),
    AccordionModule.forRoot(),
    NgxSliderModule,
    NgxNumberSpinnerModule,
    SharedModule,
    ModalModule.forRoot(),
    NgcCookieConsentModule,
    
  ]
})
export class ProductModule { }
